import * as Font from 'expo-font';
import { 
	Inter_300Light, 
	Inter_400Regular, 
	Inter_600SemiBold, 
	Inter_700Bold 
} from '@expo-google-fonts/inter';

export async function useFonts() {
	try {
		await Font.loadAsync({
			'inter-bold': Inter_700Bold,
			'inter-light': Inter_300Light,
			'inter-regular': Inter_400Regular,
			'inter-semibold': Inter_600SemiBold,
		});
	} catch (e) {
		console.warn('Font loading failed, using system fonts:', e);
	}
}

export default useFonts;
